import { TravelSearchToggles } from '@shared/store/models/travel-search-toggles';
import * as fromTravelSearchTogglesActions from '../actions/travel-search-toggles.actions';

const initialState: TravelSearchToggles = {
  flight: false,
  hotel: false,
  car: false,
  activities: false,
  multi: false,
};

export function reducer(
  state = initialState,
  action: fromTravelSearchTogglesActions.TravelSearchTogglesAction
): TravelSearchToggles {
  switch (action.type) {
    case fromTravelSearchTogglesActions.CLEAR_TRAVEL_SEARCH_TOGGLES:
      return initialState;

    case fromTravelSearchTogglesActions.UPDATE_TRAVEL_SEARCH_TOGGLES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
